import { EndpointModuleStatusWebComponent } from './component/EndpointModuleStatusWebComponent';

export { EndpointModuleStatusWebComponent };
